import React from 'react';
import Table from 'react-bootstrap/Table';

const TotalsAllTable = ({
  totalsData,
  bookLogos,
  getBookLogoUrl,
  getCellStyle,
  getTooltipText,
  onOddsClick,
  game,
  oddsCellStyle,
  periodsToShow = null  // If null, show all periods. Otherwise, array of periods to display
}) => {
  const safeGame = { away: 'TBD', home: 'TBD', gameIDmlb: 'loading', ...game };

  if (!totalsData || totalsData.length === 0) {
    return null;
  }

  // Group data by period
  const groupedByPeriod = totalsData.reduce((acc, player) => {
    const period = player.period || 'Game';
    if (!acc[period]) {
      acc[period] = [];
    }
    acc[period].push(player);
    return acc;
  }, {});

  // Define period order
  const periodOrder = ['Game', 'Q1', 'Q2', 'Q3', 'Q4', '1st Half', '2nd Half', '1st', '2nd', '3rd'];

  // Filter periods based on periodsToShow prop
  let periodsToDisplay = Object.keys(groupedByPeriod);
  if (periodsToShow && Array.isArray(periodsToShow)) {
    periodsToDisplay = periodsToDisplay.filter(period => periodsToShow.includes(period));
  }

  const sortedPeriods = periodsToDisplay.sort((a, b) => {
    const indexA = periodOrder.indexOf(a);
    const indexB = periodOrder.indexOf(b);
    return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
  });

  return (
    <div className="table-container">
      <Table bordered size="sm" className="text-center">
        <thead>
          <tr><th colSpan={bookLogos.length + 1} className="bg-light">Totals (All Periods)</th></tr>
          <tr>
            <th style={{ width: '120px' }}></th>
            {bookLogos.map(book => (
              <th key={`totals-${book}`} style={oddsCellStyle}>
                <img
                  src={getBookLogoUrl(book)}
                  alt={`${book} logo`}
                  title={book}
                  style={{ height: '20px' }}
                />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {sortedPeriods.map((periodIndex) => (
            <React.Fragment key={periodIndex}>
              {/* Period section header */}
              <tr>
                <td colSpan={bookLogos.length + 1} style={{
                  backgroundColor: 'transparent',
                  color: '#ffc107',
                  fontWeight: 'bold',
                  textAlign: 'center',
                  padding: '8px',
                  borderTop: 'none',
                  borderBottom: 'none'
                }}>
                  {periodIndex === 'Game' ? 'Totals' : `Totals ${periodIndex}`}
                </td>
              </tr>

              {/* Over Row */}
              <tr>
                <td style={{ width: '120px', fontWeight: 'bold' }}>
                  Over
                </td>
                {bookLogos.map(book => {
                  // Find over data for this period and bookmaker
                  const overData = groupedByPeriod[periodIndex].find(d =>
                    d.betType === 'over' &&
                    d[`totals_${book}`] !== null &&
                    d[`totals_${book}`] !== undefined
                  );

                  return (
                    <td
                      key={`totals-${book}-over`}
                      className="odds-cell"
                      style={{
                        ...getCellStyle(
                          overData?.[`totals_${book}`],
                          overData?.[`totals_bestBookPrice`],
                          overData?.[`totals_bestBookDiff`],
                          bookLogos.filter(b => overData?.[`totals_${b}`] !== null && overData?.[`totals_${b}`] !== undefined).length,
                          overData?.[`totals_${book}_direction`]
                        ),
                        textAlign: 'center',
                        padding: '8px 4px',
                        fontSize: '0.8rem',
                        cursor: overData ? 'pointer' : 'default'
                      }}
                      title={getTooltipText(
                        overData?.[`totals_${book}`],
                        overData?.[`totals_bestBookPrice`],
                        overData?.[`totals_bestBookDiff`],
                        bookLogos.filter(b => overData?.[`totals_${b}`] !== null && overData?.[`totals_${b}`] !== undefined).length
                      )}
                      onClick={() => {
                        if (overData && onOddsClick) {
                          onOddsClick(safeGame.gameIDmlb, null, 'over', 'totals', book, overData[`totals_${book}`], safeGame.away, safeGame.home);
                        }
                      }}
                    >
                      {overData ? (
                        <div>
                          <div style={{ fontWeight: 'bold' }}>{overData[`totals_${book}`] > 0 ? `+${overData[`totals_${book}`]}` : overData[`totals_${book}`]}</div>
                          <div style={{ fontSize: '0.75rem', color: '#6c757d' }}>o{overData.point}</div>
                        </div>
                      ) : null}
                    </td>
                  );
                })}
              </tr>

              {/* Under Row */}
              <tr>
                <td style={{ width: '120px', fontWeight: 'bold' }}>
                  Under
                </td>
                {bookLogos.map(book => {
                  // Find the over data first to get the point value
                  const overData = groupedByPeriod[periodIndex].find(d =>
                    d.betType === 'over' &&
                    d[`totals_${book}`] !== null &&
                    d[`totals_${book}`] !== undefined
                  );
                  // Find under with the same point value
                  const underData = overData ?
                    groupedByPeriod[periodIndex].find(d =>
                      d.betType === 'under' &&
                      d.point === overData.point &&
                      d[`totals_${book}`] !== null &&
                      d[`totals_${book}`] !== undefined
                    ) : null;

                  return (
                    <td
                      key={`totals-${book}-under`}
                      className="odds-cell"
                      style={{
                        ...getCellStyle(
                          underData?.[`totals_${book}`],
                          underData?.[`totals_bestBookPrice`],
                          underData?.[`totals_bestBookDiff`],
                          bookLogos.filter(b => underData?.[`totals_${b}`] !== null && underData?.[`totals_${b}`] !== undefined).length,
                          underData?.[`totals_${book}_direction`]
                        ),
                        textAlign: 'center',
                        padding: '8px 4px',
                        fontSize: '0.8rem',
                        cursor: underData ? 'pointer' : 'default'
                      }}
                      title={getTooltipText(
                        underData?.[`totals_${book}`],
                        underData?.[`totals_bestBookPrice`],
                        underData?.[`totals_bestBookDiff`],
                        bookLogos.filter(b => underData?.[`totals_${b}`] !== null && underData?.[`totals_${b}`] !== undefined).length
                      )}
                      onClick={() => {
                        if (underData && onOddsClick) {
                          onOddsClick(safeGame.gameIDmlb, null, 'under', 'totals', book, underData[`totals_${book}`], safeGame.away, safeGame.home);
                        }
                      }}
                    >
                      {underData ? (
                        <div>
                          <div style={{ fontSize: '0.75rem', color: '#6c757d' }}>u{underData.point}</div>
                          <div style={{ fontWeight: 'bold' }}>{underData[`totals_${book}`] > 0 ? `+${underData[`totals_${book}`]}` : underData[`totals_${book}`]}</div>
                        </div>
                      ) : null}
                    </td>
                  );
                })}
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default TotalsAllTable;
